import RestClientService from 'Services/RestClientService';

class DashboardApiService {
  static async getDashboardData() {
    return RestClientService.Get('dashboard');
  }

  static async getSeasons() {
    return RestClientService.Get('dashboard/seasons');
  }

  static async getAnalytics(season, dateFrom, dateTo) {
    const params = new URLSearchParams({ season });
    if (dateFrom) params.append('dateFrom', dateFrom);
    if (dateTo) params.append('dateTo', dateTo);
    return RestClientService.Get(`dashboard/analytics?${params.toString()}`);
  }
}

export default DashboardApiService;
